import { useEffect, useState } from "react";
import axios from "axios";
import { CheckCircle, AlertCircle, Loader2 } from "lucide-react";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function OptInConfirmPage() {
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("Confirming your preferences…");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token") || "";
    if (!token) {
      setStatus("error");
      setMessage("This confirmation link is missing a token.");
      return undefined;
    }
    let cancelled = false;
    const confirm = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/public/visitor/confirm-opt-in`, {
          params: { token },
        });
        if (cancelled) return;
        setStatus("success");
        setMessage(response.data?.message || "Your Westgate updates preference is confirmed.");
      } catch (error) {
        if (cancelled) return;
        setStatus("error");
        const detail = error?.response?.data?.detail;
        setMessage(
          typeof detail === "string" && detail.trim()
            ? detail
            : "We could not confirm this link. It may be invalid or expired."
        );
      }
    };
    confirm();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#F7F0E8] flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white shadow-xl rounded-xl overflow-hidden">
        <div className="bg-gradient-to-r from-[#EC1A23] to-[#561D1A] p-6 text-white text-center">
          <h1 className="text-xl font-extrabold tracking-tight">Westgate Mall</h1>
          <p className="text-white/85 text-sm mt-1">Updates preference</p>
        </div>
        <div className="p-6 text-center space-y-3">
          {status === "loading" ? (
            <Loader2 className="h-10 w-10 mx-auto animate-spin text-[#EC1A23]" />
          ) : null}
          {status === "success" ? (
            <CheckCircle className="h-10 w-10 mx-auto text-emerald-600" />
          ) : null}
          {status === "error" ? (
            <AlertCircle className="h-10 w-10 mx-auto text-[#EC1A23]" />
          ) : null}
          <p className="text-sm text-[#561D1A] font-medium leading-relaxed">{message}</p>
          {status === "success" ? (
            <a
              href="/chat"
              className="inline-flex mt-2 min-h-11 items-center justify-center px-4 py-2 rounded-lg bg-[#EC1A23] text-white text-sm font-semibold"
            >
              Open Customer Support
            </a>
          ) : null}
        </div>
      </div>
    </div>
  );
}
